import { EHANDOVER_TAB_IDS } from '../constants/config';

// 生成 EHandover 各 tab 列表数据的初始对象 state。
// 这里只初始化 tab 自己的 list / next / total，不混入页面控制状态，方便后续持续收口。
export const createInitialTabListStateById = () => ({
  [EHANDOVER_TAB_IDS.PIN_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.SENT_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.CHECKLIST_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.OUTSTANDING_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.COMPLETED_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.SCHEDULE_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.MY_DRAFT_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.DELETED_TAB]: { list: [], next: null, total: 0 },
  [EHANDOVER_TAB_IDS.NOTIFICATION_TAB]: { list: [], total: 0 },
  [EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB]: { list: [], next: null, total: 0 },
});

// 统一生成“按 tab 维度查看”的 total 映射。
// checklist tab 的标题 total 仍然来自 followTotal 这条现有业务链，其它 tab 都直接读统一对象 state。
export const createTabCountsById = ({ followTotal, tabListStateById }) => ({
  [EHANDOVER_TAB_IDS.PIN_TAB]: tabListStateById[EHANDOVER_TAB_IDS.PIN_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.SENT_TAB]: tabListStateById[EHANDOVER_TAB_IDS.SENT_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.CHECKLIST_TAB]: followTotal,
  [EHANDOVER_TAB_IDS.OUTSTANDING_TAB]: tabListStateById[EHANDOVER_TAB_IDS.OUTSTANDING_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.COMPLETED_TAB]: tabListStateById[EHANDOVER_TAB_IDS.COMPLETED_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.SCHEDULE_TAB]: tabListStateById[EHANDOVER_TAB_IDS.SCHEDULE_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.MY_DRAFT_TAB]: tabListStateById[EHANDOVER_TAB_IDS.MY_DRAFT_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.DELETED_TAB]: tabListStateById[EHANDOVER_TAB_IDS.DELETED_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.NOTIFICATION_TAB]: tabListStateById[EHANDOVER_TAB_IDS.NOTIFICATION_TAB]?.total ?? 0,
  [EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB]: tabListStateById[EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB]?.total ?? 0,
});

// 统一生成“按 tab 维度查看”的列表只读视图。
// 这里继续返回按 tabId 组织的只读视图，但数据已经直接来自统一的 tabListStateById。
export const createTabStateById = ({ myDraftLoaded, notificationTaskLength, tabCountsById, tabListStateById }) => ({
  ...tabListStateById,
  [EHANDOVER_TAB_IDS.CHECKLIST_TAB]: {
    ...tabListStateById[EHANDOVER_TAB_IDS.CHECKLIST_TAB],
    total: tabCountsById[EHANDOVER_TAB_IDS.CHECKLIST_TAB],
  },
  [EHANDOVER_TAB_IDS.MY_DRAFT_TAB]: {
    ...tabListStateById[EHANDOVER_TAB_IDS.MY_DRAFT_TAB],
    loaded: myDraftLoaded,
  },
  [EHANDOVER_TAB_IDS.NOTIFICATION_TAB]: {
    ...tabListStateById[EHANDOVER_TAB_IDS.NOTIFICATION_TAB],
    next: tabCountsById[EHANDOVER_TAB_IDS.NOTIFICATION_TAB] > notificationTaskLength,
  },
});
